var $ = require("jquery");

$(document).ready(function () {

  var el = $('.fon h3');


  $(".fon").removeClass("d-none");

  function size() {
    var width = $('#menu-hauptmenue').innerWidth();
    el.css("width", width + "px")
    el.css("padding-right", "0")
    if ($(window).width() < 1448) {
      el.css("padding-right", "3rem")
    }
  }

  $(window).resize(function () {
    size();
  });

  setTimeout(size, 0);
  setTimeout(size, 100);
  setTimeout(size, 300);

});
